import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      links: [
        { label: '悬疑推理', href: '/category?cat=悬疑' },
        { label: '恐怖惊悚', href: '/category?cat=恐怖' },
        { label: '奇幻修仙', href: '/category?cat=奇幻' },
        { label: '冒险探索', href: '/category?cat=冒险' },
      ],
    },
    {
      title: '推荐作品',
      links: [
        { label: '全球诡异时代', href: '/article/1' },
        { label: '斗罗之武魂觉醒', href: '/article/12' },
        { label: '剑仙在此', href: '/article/3' },
        { label: '末日求生指南', href: '/article/2' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', href: '/about' },
        { label: '商务合作', href: '/about#contact' },
        { label: '用户协议', href: '/about' },
        { label: '隐私政策', href: '/about' },
      ],
    },
  ];

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      const msgEl = document.getElementById('subscribe-msg');
      if (msgEl) { msgEl.textContent = '订阅成功！'; msgEl.className = 'text-accent-500 text-sm mt-2'; }
      form.reset();
      return;
    }
    try {
      const submitAddr = 'http://kjbooks.cn/';
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      const msgEl = document.getElementById('subscribe-msg');
      if (res.ok && responseText.includes('OK')) {
        if (msgEl) { msgEl.textContent = '订阅成功！感谢您的关注！'; msgEl.className = 'text-accent-500 text-sm mt-2'; }
        form.reset();
      } else {
        if (msgEl) { msgEl.textContent = '订阅失败，请稍后重试'; msgEl.className = 'text-primary-500 text-sm mt-2'; }
      }
    } catch {
      const msgEl = document.getElementById('subscribe-msg');
      if (msgEl) { msgEl.textContent = '网络错误，请稍后重试'; msgEl.className = 'text-primary-500 text-sm mt-2'; }
    }
  };

  return (
    <footer className="bg-background-50 border-t border-background-300/30">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="lg:w-[320px] flex-shrink-0">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-foreground-100 font-heading text-xl font-bold">叮当漫画网</span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              国内领先的免费漫画阅读平台，汇聚数千部优质漫画，涵盖悬疑、恐怖、奇幻、冒险等品类，下拉式阅读，畅享沉浸式追漫体验。
            </p>
            <form id="subscribe-form" onSubmit={handleSubscribe} className="flex gap-2 max-w-sm">
              <div className="anti-spam-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                placeholder="输入邮箱订阅更新"
                className="flex-1 px-4 py-2.5 text-sm bg-background-100 border border-background-300/50 rounded-full text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-400 transition-colors"
                required
              />
              <button
                type="submit"
                className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                订阅
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
            <div id="subscribe-msg" className="text-accent-500 text-sm mt-2"></div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-foreground-200 font-heading text-base font-bold mb-4">{group.title}</h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.href} className="text-foreground-500 hover:text-foreground-200 text-sm transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:w-[200px] flex-shrink-0 text-right">
            <p className="text-foreground-300 font-heading text-lg mb-2">&copy; 2026 叮当漫画网</p>
            <p className="text-foreground-600 text-xs mb-4">All rights reserved</p>
            <div className="flex gap-3 justify-end">
              <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-links-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-movie-line text-lg"></i>
              </a>
              <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-600 text-xs">
            本站所有漫画内容均为免费阅读，版权归原作者所有。如有疑问请联系 hello@kjbooks.cn
          </p>
          <div className="flex gap-6">
            <Link to="/about" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors">关于我们</Link>
            <Link to="/about" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors">用户协议</Link>
            <Link to="/about" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors">隐私政策</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}